import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getManagementMetrics() {
    try {
        const response = await axios.get(`${LEADS_ENDPOINT}/metrics`)
        return response.data.data
    } catch (error) {
        console.log('error', error)
        return Promise.reject(error)
    }
}
